var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5317,
    cy: 17.3208,
    r: 16.1408,
    stroke: "#17A2B8",
    strokeWidth: 1.89892
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0084 25.866C21.7261 25.8659 25.0451 23.9696 26.8867 20.7935C27.1776 20.2917 27.005 19.6502 26.5012 19.3605C25.9974 19.0708 25.3531 19.2426 25.0622 19.7444C23.6014 22.2638 20.9644 23.7679 18.0083 23.768C15.0522 23.768 12.415 22.2638 10.954 19.7444C10.6632 19.2427 10.019 19.0708 9.51505 19.3606C9.01126 19.6502 8.8387 20.2918 9.12964 20.7935C10.9714 23.9698 14.2906 25.866 18.0084 25.866Z",
    fill: "#17A2B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1949 13.9975C13.3747 13.9975 14.3312 13.0411 14.3312 11.8613C14.3312 10.6814 13.3747 9.72498 12.1949 9.72498C11.015 9.72498 10.0586 10.6814 10.0586 11.8613C10.0586 13.0411 11.015 13.9975 12.1949 13.9975Z",
    fill: "#17A2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8707 13.9975C24.0505 13.9975 25.0069 13.0411 25.0069 11.8613C25.0069 10.6814 24.0505 9.72498 22.8707 9.72498C21.6908 9.72498 20.7344 10.6814 20.7344 11.8613C20.7344 13.0411 21.6908 13.9975 22.8707 13.9975Z",
    fill: "#17A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.d1eee2fcb3b7f7a69568c28cac64bd20.svg";
export { ForwardRef as ReactComponent };